import { H4 } from "@/components/reusables/typography";
import { Progress } from "@/components/ui/progress";
import { T_WasteManagementData } from "@/interfaces/customer-portal/waste-management.interface";
import { formatToCapitalizedWords } from "@/lib/utils";

const RecoveryPathChart = ({
  wasteManagementData,
}: {
  wasteManagementData: T_WasteManagementData;
}): React.JSX.Element => {
  const recoveryPathway = wasteManagementData?.recoveryPathway;
  const total =
    (recoveryPathway?.RECYCLE ?? 0) +
    (recoveryPathway?.REUSE ?? 0) +
    (recoveryPathway?.ENERGYCONVERSION ?? 0) +
    (recoveryPathway?.LANDFILL ?? 0);

  const finalData = {
    recycle: {
      value: (100 / total) * (recoveryPathway?.RECYCLE || 0),
      color: "red",
    },
    "Reuse / Resale": {
      value: (100 / total) * (recoveryPathway?.REUSE || 0),
      color: "blue",
    },
    energyRecovery: {
      value: (100 / total) * (recoveryPathway?.ENERGYCONVERSION || 0),
      color: "green",
    },
    landfill: {
      value: (100 / total) * (recoveryPathway?.LANDFILL || 0),
      color: "yellow",
    },
  };

  return (
    <div className='p-4 border rounded-lg h-44 flex flex-col gap-4 min-w-fit w-fit'>
      <h2 className='text-xl font-normal'>Recovery Pathway</h2>
      <div className=' h-[90%] flex-col gap-2'>
        <div className='w-full grid grid-cols-4 gap-16'>
          {Object.entries(finalData).map(([key, value]) => (
            <div className='flex flex-col gap-2' key={key}>
              <h2 className='text font-medium text-black/70'>
                {formatToCapitalizedWords(key)}
              </h2>
              <div className='flex flex-col gap-4'>
                <H4 className='text-black/70'>
                  {!isNaN(value?.value) ? Number(value?.value.toFixed(2)) : 0}{" "}
                  <span>%</span>
                </H4>
                <Progress
                  className='w-full h-1.5'
                  segments={[
                    {
                      value: !isNaN(value?.value)
                        ? Number(value?.value.toFixed(2))
                        : 0,
                      color: value?.color,
                    },
                  ]}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecoveryPathChart;
